export default "assets/images/icons/facebook-e31a7719.svg";